<template>
    <Cascader :data="dicData" change-on-select v-model="dicValue"></Cascader>
</template>
<script>
import util from '@/libs/util.js'
export default {
  name: 'CtsiDicMultiSelect',
  model: {
    // 使用model， 这儿2个属性，prop属性说，我要将value作为该组件被使用时,v-model能取到的值，event说，我emit ‘cc’ 的时候，参数的值就是父组件v-model收到的值。
    prop: 'value',
    event: 'changeValue'
  },
  props: { 'rootValue': {}, 'fromValue': {}, 'showFrom': { default: true }, 'value': {} },
  data () {
    return {
      dicData: [],
      from: this.fromValue ? this.fromValue : this.rootValue
    }
  },
  computed: {
    dicValue: {
      get: function () {
        return this.value // 将props中的value赋值给currentValue
      },
      set: function (value) {
        this.$emit('changeValue', value) // 通过$emit触发父组件
      }
    }
  },
  methods: {
    initData () {
      var vm = this
      let _params = { 'rootValue': this.rootValue, 'fromValue': this.from, 'showFrom': this.showFrom }
      util.http.get('/api/system/cscpMultiDicsListLable', { params: _params }).then(function (data) {
        let pids = []; let list = []
        let _data = data.data
        let parentId = getParentId(_data, 'id', 'dicParentId')
        if (parentId.length > 1) {
          for (var i = 0; i < parentId.length; i++) {
            var tList = switchToTree(_data, parentId[i], pids, { id: 'id', pid: 'dicParentId' })
            list = list.concat(tList)
          }
        } else {
          list = switchToTree(_data, parentId[0], pids, { id: 'id', pid: 'dicParentId' })
        }
        vm.dicData = list
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  created () {
    this.initData()
    util.statistic('baseComp', 'ctsi-dic-multi-select', '')
  }
}
function switchToTree (data, parent_id, pids, params) {
  var tree = []
  var temp = []
  for (var i = 0; i < data.length; i++) {
    if (data[i][params['pid']] == parent_id) {
      var obj = {
        value: data[i].id,
        label: data[i].dicName
      }
      temp = switchToTree(data, data[i][params['id']], pids, params)
      if (temp.length > 0) {
        obj.children = temp
      }
      tree.push(obj)
      pids.push(parent_id)
    }
  }
  return tree
}
function getParentId (json, id, pid) {
  var idArray = []; var pidArray = []
  for (let i = 0; i < json.length; i++) {
    if (!isInArray(json[i][id], idArray)[0]) {
      idArray.push(json[i][id])
    }
  }
  for (let i = 0; i < json.length; i++) {
    if (isInArray(json[i][pid], idArray)[0] == false && isInArray(json[i][pid], pidArray)[0] == false) {
      pidArray.push(json[i][pid])
    }
  }
  return pidArray
}
function isInArray (obj, array) {
  var isIn = false
  var num = null
  for (var i = 0; i < array.length; i++) {
    if (obj == array[i]) {
      isIn = true
      num = i
    }
  }
  return [isIn, num]
}
</script>
